import { CATALOGUE_POLICES, policesDeLaCharte } from '../../contract/index.js';
import { Corps } from './Corps.js';
import { cssAccrochage } from './css.js';
/**
 * Polices du thème : déclarées, jamais téléchargées (D12). La publication
 * copie ces fichiers depuis le dépôt de polices d'Artosera vers `/fonts/`.
 */
function assets(charte) {
    return policesDeLaCharte(charte).flatMap((nom) => {
        const definition = CATALOGUE_POLICES[nom];
        return definition.fichiers.map((fichier) => ({
            chemin: fichier.chemin,
            type: 'police',
            description: `${definition.famille} ${String(fichier.graisse)} ${fichier.style}`,
        }));
    });
}
/**
 * Thème **Accrochage**, d'après `designs/c-accrochage.html` : l'accrochage au
 * mur — image d'abord, grilles pleines, plein écran, blanc, peu de texte.
 * Pour l'art contemporain et la photographie.
 */
export const accrochage = {
    nom: 'accrochage',
    feuilleDeStyle: '/assets/accrochage.css',
    assets,
    css: cssAccrochage,
    Corps,
};
export { cssAccrochage };
//# sourceMappingURL=index.js.map